import { clamp01, easeOutBack } from "./visual-motion";
export function koTimeline(t: number, reduced = false) {
  if (reduced)
    return {
      timeScale: 1,
      worldMs: Math.max(0, t),
      dolly: 0,
      zoom: 0,
      fall: 0,
      stampScale: 1,
      stampAlpha: t < 300 ? 1 : 1 - clamp01((t - 300) / 100),
      flash: 0,
    };
  let worldMs = 0,
    timeScale = 0;
  if (t > 150 && t <= 1350) {
    worldMs = (t - 150) * 0.3;
    timeScale = 0.3;
  } else if (t > 1350 && t < 1600) {
    const q = t - 1350;
    worldMs = 360 + q * 0.3 + (0.35 * q * q) / 250;
    timeScale = 0.3 + (0.7 * q) / 250;
  } else if (t >= 1600) {
    worldMs = 522.5 + t - 1600;
    timeScale = 1;
  }
  const p = clamp01((t - 150) / 1200);
  return {
    timeScale,
    worldMs,
    dolly: 0.6 * p,
    zoom: 6 * p,
    fall: ((80 * Math.PI) / 180) * easeOutBack(p, 1.2),
    stampScale: 3 - 2 * easeOutBack(t / 150, 2),
    stampAlpha: t < 1350 ? 1 : 1 - clamp01((t - 1350) / 250),
    flash: 0.6 * (1 - clamp01(t / 120)),
  };
}
export function endTransition(t: number, ko: boolean, reduced = false) {
  const lead = ko ? (reduced ? 300 : 1600) : 0,
    wipe = t - lead;
  const total = lead + (reduced ? 200 : 640),
    swapAt = lead + (reduced ? 100 : 260);
  if (reduced)
    return {
      total,
      swapAt,
      mode: "fade" as const,
      progress: 0,
      alpha:
        wipe < 0
          ? 0
          : wipe < 100
            ? clamp01(wipe / 100)
            : 1 - clamp01((wipe - 100) / 100),
    };
  if (wipe < 0)
    return { total, swapAt, mode: "none" as const, progress: 0, alpha: 0 };
  if (wipe < 260)
    return {
      total,
      swapAt,
      mode: "close" as const,
      progress: clamp01(wipe / 260) ** 3,
      alpha: 1,
    };
  if (wipe < 320)
    return { total, swapAt, mode: "hold" as const, progress: 1, alpha: 1 };
  return {
    total,
    swapAt,
    mode: "open" as const,
    progress: 1 - (1 - clamp01((wipe - 320) / 320)) ** 3,
    alpha: 1,
  };
}
